/** Shared register candidate status helpers / constants. */

export const REGISTER_STATUS_OPTIONS = [
  {
    id: 'interested',
    label: 'Interested',
    hint: 'Reach out about enrollment',
    tone: 'success',
  },
  {
    id: 'future',
    label: 'Future follow-up',
    hint: 'Contact again later',
    tone: 'info',
  },
  {
    id: 'disabled',
    label: 'Disabled',
    hint: 'Not interested — do not contact',
    tone: 'danger',
  },
  {
    id: 'created',
    label: 'Created (candidate)',
    hint: 'Onboarded as platform candidate',
    tone: 'neutral',
  },
];

const STATUS_BY_ID = Object.fromEntries(REGISTER_STATUS_OPTIONS.map((s) => [s.id, s]));

/** Disabled / inactive statuses hidden by the default Register list filter. */
export const INACTIVE_REGISTER_STATUSES = new Set(['disabled']);

/** Default list view: active pipeline only (not disabled/inactive). */
export const DEFAULT_REGISTER_STATUS_FILTER = 'active';

export function statusLabel(status) {
  return STATUS_BY_ID[status]?.label || status || 'Interested';
}

export function statusTone(status) {
  return STATUS_BY_ID[status]?.tone || 'neutral';
}

export function normalizeRegisterStatus(value) {
  const s = String(value || 'interested').toLowerCase().trim();
  if (s === 'created_as_candidate') return 'created';
  if (s === 'future_followup') return 'future';
  if (s === 'not_interested' || s === 'inactive') return 'disabled';
  if (STATUS_BY_ID[s]) return s;
  return 'interested';
}

/** True when the register row should appear under the default "active" list filter. */
export function isRegisterStatusActive(status) {
  return !INACTIVE_REGISTER_STATUSES.has(normalizeRegisterStatus(status));
}

/**
 * Does a list row pass the Register status filter control?
 * - active (default): exclude disabled/inactive
 * - all: every status
 * - otherwise: exact status id
 */
export function matchesRegisterStatusFilter(rowStatus, statusFilter) {
  const filter = statusFilter || DEFAULT_REGISTER_STATUS_FILTER;
  if (filter === 'all') return true;
  if (filter === 'active') return isRegisterStatusActive(rowStatus);
  return normalizeRegisterStatus(rowStatus) === filter;
}
